import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "paul.mv07 photography";
const DEFAULT_DESC =
    "Photographe automobile et lifestyle en France — mariages, baptêmes, portraits et shootings sur mesure. Style cinématographique et intime.";
const DEFAULT_IMG = "https://images.unsplash.com/photo-1485291571150-772bcfc10da5?auto=format&fit=crop&w=1200&q=80";

export default function SEO({ title, description, image, path }) {
    const fullTitle = title ? `${title} — ${SITE}` : `${SITE} — Photographe automobile, mariage, baptême`;
    const desc = description || DEFAULT_DESC;
    const url = `${typeof window !== "undefined" ? window.location.origin : ""}${path || (typeof window !== "undefined" ? window.location.pathname : "")}`;
    const img = image || DEFAULT_IMG;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            <link rel="canonical" href={url} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:image" content={img} />
            <meta property="og:url" content={url} />
            <meta property="og:site_name" content={SITE} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={desc} />
            <meta name="twitter:image" content={img} />
            <meta name="theme-color" content="#0a0a0a" />
        </Helmet>
    );
}
